import {EntityType, NewJoiner, NewJoinerForm} from "./Model";
import {EntityStore, startEntityStore} from "./resourceStoreBuilder";
import {create} from "zustand";
import {officeArrayResource} from "./CurrentOfficeStore";
import {NewJoiners_Read} from "../util/access/Permission";

interface NewJoinerStore extends EntityStore<NewJoiner[]> {
    createNewJoiner: (form: NewJoinerForm) => Promise<NewJoiner>;
    updateNewJoiner: (newJoiner: NewJoiner, form: NewJoinerForm) => Promise<NewJoiner>;
    deleteNewJoiner: (newJoiner: NewJoiner) => Promise<void>;
}

export const useNewJoinerStore = create<NewJoinerStore>()(
    officeArrayResource<NewJoiner, NewJoinerStore>(EntityType.NewJoiners, builder => {
        const rest = builder.crud('/new-joiners', 'id');

        return {
            remoteValue: builder.all(NewJoiners_Read, () => rest.getAll()),
            createNewJoiner: builder.createAndPatch<NewJoinerForm>(rest),
            updateNewJoiner: builder.updateAndPatch<NewJoinerForm>(rest, undefined, (a, b) => a.id === b.id),
            deleteNewJoiner: builder.deleteAndPatch(rest),
        };
    })
);

startEntityStore(useNewJoinerStore);
